import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import { Enums, Tables } from '../types/supabase';

export type SubscriptionTier = Enums<'subscription_tier'>
export type Subscription = Tables<'subscriptions'>

interface SubscriptionStore {
  subscription: Subscription | null;
  loading: boolean;
  error: string | null;
  initialized: boolean;
  fetchSubscription: (userId: string) => Promise<void>;
  refreshSubscription: (chatbotUserId?: string) => Promise<void>;
  initializeSubscription: (chatbotUserId?: string) => Promise<void>;
}

export const useSubscription = create<SubscriptionStore>((set, get) => ({
  subscription: null,
  loading: false,
  error: null,
  initialized: false,

  fetchSubscription: async (userId) => {
    try {
      set({ loading: true, error: null });

      const { data, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', userId)
        .single();

      if (error) {
        throw error;
      }

      set({
        subscription: data,
        initialized: true
      });
    } catch (err) {
      set({ error: err instanceof Error ? err.message : 'Error loading subscription' });
    } finally {
      set({ loading: false });
    }
  },

  refreshSubscription: async (chatbotUserId?: string) => {
    try {
      if (chatbotUserId) {
        await get().fetchSubscription(chatbotUserId);
        return;
      }

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      await get().fetchSubscription(user.id);
    } catch (err) {
      // Error handled silently
    }
  },

  initializeSubscription: async (chatbotUserId?: string) => {
    // Skip if already initialized or currently loading
    if (get().initialized || get().loading) return;
    
    try {
      if (chatbotUserId) {
        await get().fetchSubscription(chatbotUserId);
        return;
      }

      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      
      await get().fetchSubscription(user.id);
    } catch (err) {
      // Error handled silently
    }
  }
}));